// extracted by mini-css-extract-plugin
export default {"container":"CustomInput_container__cNIEu","input":"CustomInput_input__ObazE"};